import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxeNedebitateAchitateComponent } from './taxe-nedebitate-achitate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [TaxeNedebitateAchitateComponent],
  imports: [
    CommonModule,
    MaterialModule, FormsModule, ReactiveFormsModule
  ]
})
export class TaxeNedebitateAchitateModule { }
